import { shippingGiftCalculatorInit } from "../../cartDrawerFreeShippingCalculator/scripts";

document.addEventListener("DOMContentLoaded", () => {

	if ( document.querySelector('[shipping-modal-enabled]') ) {		

		let countryMinFreeShipping = sessionStorage.getItem("CountryMinFreeShipping");

		function replaceVariables (textToReplace, newText) {
			let announcementElement = document.querySelector('[shipping-modal-enabled] .announcement-bar__text');
			let announcementText = announcementElement.textContent;
			announcementElement.textContent = announcementText.replace(textToReplace, newText);
		}

		function checkFreeShippingAmount(t,e) {
			if (countryMinFreeShipping) {
				countryMinFreeShipping = Number(countryMinFreeShipping).toFixed(2);
				replaceVariables("[VALUE]", countryMinFreeShipping);
				shippingGiftCalculatorInit();
			} else {
				if(t) {
					e[0].classList.add('country-search-result');
					let amount = document.querySelector('.country-search-result .free.min-amount').innerHTML.split(" ");
					sessionStorage.setItem("CountryMinFreeShipping", amount[0]);
					let final = Number(amount[0]).toFixed(2);
					replaceVariables ("[VALUE]", final);
					shippingGiftCalculatorInit();
				}
			}

			
		}

		async function fetchLocationInformation() {
			const access_key = document.querySelector('[data-ipstack-access-key]').getAttribute('data-ipstack-access-key');
			if (!access_key) {
				console.error('IPStack key is missing');
				return;
			}

			let response = await fetch('https://api.ipstack.com/check?access_key=' + access_key);
			let data = await response.json();
			document.getElementById('shipping-search').value = data.country_name;
			sessionStorage.setItem('IPStackVisitorCountry', data.country_name);
			$("#shipping-search").trigger("keyup");
			replaceVariables ("[COUNTRY]", data.country_name);
		}
	
		async function fetchShippingRates() {

			let data;
			let shippingRates = sessionStorage.getItem('StoreShippingRates');

			if (shippingRates) {
				data = JSON.parse(shippingRates);
			} else {
				let store = Shopify.shop;			
				let response = await fetch(`https://netlify.blacklemon.dk/.netlify/functions/getShippingZones?store=${store}`);
				data = await response.json();
				sessionStorage.setItem('StoreShippingRates', JSON.stringify(data));
			}
			
			populateTable(data);
			inputCountryCheck();
		}
	
	
		let working_days = shippingTranslationKeys["shipping_modal.shipping_table.working_days"];

		let currency = {
			EUR: "€",
			USD: "$",
			GBP: "£",
			DKK: "DKK"
		}
		
		function populateTable(data) {	
			let countryListLength = document.querySelectorAll('tbody.country.tbody-country').length;
	
			if( countryListLength < 2 ) {
				data.forEach(e => {
					let o = $(".tbody-country:last");
					o.clone().appendTo(".shipping-prices-table"), e.forEach(function(e, t) {
						var n = o.find(".shipping-row:last");
						n.clone().appendTo(o), n.append('<th class="shipping col--shipping" scope="row">'.concat(e.shipping_name, "</th>")), n.append('<td class="delivery col--delivery">'.concat(e.days.split(' ')[0], " ").concat(working_days, "</td>")), n.append('<td class="price">'.concat(e.price, " ").concat(currency[Shopify.currency.active], "</td>")), "N/A" === e.free_above ? n.append('<td class="free">'.concat(e.free_above, "</td>")) : n.append('<td class="free min-amount">'.concat(e.free_above, " ").concat(currency[Shopify.currency.active], "</td>"))
					}), o.find(".shipping-row").eq(0).find(".col--country").text(e[0].country), o.find(".shipping-row").not(":eq(0)").find(".col--country").remove();
				});
			}	
		}
	
	
		function inputCountryCheck() {
			$(".shipping-info-container__table").each(function(e) {
				var t = $(this);
				t.find("#shipping-search").on("keyup loaded change ready focus", function() {
	
					if ($(this).val().length > 2) {
						var n = $(this).val().toLowerCase(),
						o = 0;
						t.find("tbody.country").filter(function() {
							var e = $(this),
								t = -1 < e.text().toLowerCase().indexOf(n);
							e.toggle(t), o += t ? 1 : 0;
							checkFreeShippingAmount(t, e);
						}), 0 === o && t.find("tbody.country").filter(function() {
							var e = $(this),
								t = -1 < e.text().toLowerCase().indexOf("rest of world");
								checkFreeShippingAmount(t, e);						
							e.toggle(t);
						})
					} else {
						t.find("tbody.country").filter(function() {
							var e = $(this),
								t = -1 < e.text().toLowerCase().indexOf("rest of world");
								checkFreeShippingAmount(t, e);
							e.toggle(t);
						})
					}
					
	
				}), t.find("#shipping-search").trigger("keyup"), t.find("tbody.country").on("click", function() {
					var e = $(this).find("p");
					e.is("visible"), e.slideToggle("fast").toggleClass("el-content")
				});
			});
		}
	
		let visitorCountry = sessionStorage.getItem('IPStackVisitorCountry');

		if ( visitorCountry ) {
			document.getElementById('shipping-search').value = visitorCountry;
			fetchShippingRates();
			$("#shipping-search").trigger("keyup");
			replaceVariables ("[COUNTRY]", visitorCountry);
		} else {
			fetchLocationInformation();
			fetchShippingRates();
			$("#shipping-search").trigger("keyup");
		}
		
		document.querySelectorAll("#shopify-section-announcement-bar .announcement-bar[shipping-modal-enabled]").forEach(el => {
			el.addEventListener("click", function (event) {	
				  document
					.querySelector(".shipping-modal")
					.open();
				  return true;
			  });
		});
	}
});
